import React from "react";
import { Link } from "react-router-dom";
import {
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaMapMarkerAlt,
  FaPhoneAlt,
} from "react-icons/fa";
import { logo } from "../views/static";

export default function Footer() {
  const apiKey = "AIzaSyCmm700IOFHJqcGgIvYc7soxKsSqkaDefo";
  const placeId = "ChIJA6jxy2h1txsR2r40a5NbalI"; 
  const mapEmbedUrl = `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=place_id:${placeId}`;
    
  return (
    <>
      <div className="row mt-3 m-0 p-0">
        <div className="col-12 p-0">
          <div className="rounded-0 overflow-hidden shadow-lg border border-secondary" style={{ height: '300px', width: '100%' }}>
            <iframe
              title="Localização CENFOTEP"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              src={mapEmbedUrl}
            ></iframe>
          </div>
        </div>
      </div>
       <footer className="site-footer">
      <div className="site-container footer-grid">
        <div className="footer-brand">
          <div className="brand brand-light">
            <span className="brand-mark">
              <img src={logo} alt="" />
            </span>
            <span>
              <strong>CENFOTEP</strong>
              <small>Formação & Tecnologias</small>
            </span>
          </div>
          <p>
            Competências práticas, tecnologia e serviços criativos para pessoas
            e organizações que querem avançar.
          </p>
          <div className="social-row">
            <a href="https://facebook.com/cenfotep" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="https://instagram.com/cenfotep" aria-label="Instagram">
              <FaInstagram />
            </a>
          </div>
        </div>
        <div>
          <h3>Explorar</h3>
          <Link to="/sobre">Sobre nós</Link>
          <Link to="/cursos">Cursos</Link>
          <Link to="/servicos">Serviços</Link>
          <Link to="/blog">Notícias</Link>
        </div>
        <div>
          <h3>Soluções</h3>
          <Link to="/servicos">Formação profissional</Link>
          <Link to="/servicos">Consultoria em TI</Link>
          <Link to="/servicos">Gráfica e repografia</Link>
          <Link to="/empresas">Para empresas</Link>
        </div>
        <div>
          <h3>Contactos</h3>
          <p>
            <FaPhoneAlt /> +244 933 288 89
          </p>
          <p>
            <FaEnvelope /> cenfotep@outlook.com
          </p>
          <p>
            <FaMapMarkerAlt /> Huambo, Angola
          </p>
          <Link className="footer-button" to="/contato">
            Fale connosco
          </Link>
        </div>
      </div>
      <div className="site-container footer-bottom">
        <span>© 2026 CENFOTEP. Todos os direitos reservados.</span>
        <span>
          <Link to="/termos">Termos</Link>
          <Link to="/privacidade">Privacidade</Link>
          <Link to="/cookies">Cookies</Link>
        </span>
      </div>
    </footer>
    </>
   
  );
}
